import { lazy, Suspense, useEffect, useState } from 'react';
import { Play } from 'lucide-react';

const loadMuxPlayer = () => import('@mux/mux-player-react');
const MuxPlayer = lazy(loadMuxPlayer);

export default function ClickToPlayMuxVideo({ playbackId, title, warmPlayer = true }: { playbackId: string; title: string; warmPlayer?: boolean }) {
  const [playing, setPlaying] = useState(false);
  const poster = `https://image.mux.com/${playbackId}/thumbnail.webp?width=1280&time=1`;

  useEffect(() => {
    if (!warmPlayer) return;
    const timer = window.setTimeout(() => void loadMuxPlayer(), 1800);
    return () => window.clearTimeout(timer);
  }, [warmPlayer]);

  return (
    <div className="relative aspect-video w-full overflow-hidden rounded-xl bg-black shadow-lg">
      {playing ? (
        <Suspense fallback={<p role="status" className="absolute inset-0 flex items-center justify-center text-white">Loading video...</p>}>
          <MuxPlayer
            playbackId={playbackId}
            streamType="on-demand"
            autoPlay
            playsInline
            poster={poster}
            title={title}
            className="absolute inset-0 w-full h-full"
            style={{ '--media-object-fit': 'contain' }}
          />
        </Suspense>
      ) : (
        <button type="button" onPointerDown={() => void loadMuxPlayer()} onClick={() => setPlaying(true)} className="absolute inset-0 h-full w-full cursor-pointer group" aria-label={`Play ${title}`}>
          <img src={poster} srcSet={`https://image.mux.com/${playbackId}/thumbnail.webp?width=480&time=1 480w, https://image.mux.com/${playbackId}/thumbnail.webp?width=960&time=1 960w, ${poster} 1280w`} sizes="(max-width: 640px) calc(100vw - 32px), 896px" alt={title} width={1280} height={720} loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover" />
          <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors" />
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="flex h-16 w-16 items-center justify-center rounded-full bg-white/95 shadow-lg transition-colors group-hover:bg-white md:h-20 md:w-20">
              <Play className="ml-1 h-7 w-7 text-gray-900 md:h-8 md:w-8" fill="currentColor" />
            </div>
          </div>
        </button>
      )}
    </div>
  );
}
